/* Alcove — comportements de la page d'accueil.
   Sans dépendance. Rejoué sur shopify:section:load pour que l'éditeur de thème
   reste fluide, et idempotent : chaque noeud n'est initialisé qu'une fois. */
(function () {
  'use strict';

  var INIT = 'alcInit';

  /* ---------- la nuit : bascule sans orthèse / avec Alcove ---------- */
  function initNight(root) {
    var panels = root.querySelectorAll('[data-alc-night]');
    Array.prototype.forEach.call(panels, function (scope) {
      if (scope.dataset[INIT]) return;
      scope.dataset[INIT] = '1';

      var buttons = scope.querySelectorAll('[data-state]');
      var panel = scope.querySelector('.night-panel');
      var snore = scope.querySelector('.curve-snore');
      var calm = scope.querySelector('.curve-calm');
      var stats = scope.querySelectorAll('[data-stat]');
      if (!buttons.length || !panel) return;

      function apply(state) {
        var isAfter = state === 'after';

        Array.prototype.forEach.call(stats, function (stat) {
          var num = stat.querySelector('.num');
          var lab = stat.querySelector('.lab');
          var nKey = isAfter ? 'numAfter' : 'numBefore';
          var lKey = isAfter ? 'labAfter' : 'labBefore';
          if (num && stat.dataset[nKey] !== undefined) num.textContent = stat.dataset[nKey];
          if (lab && stat.dataset[lKey] !== undefined) lab.textContent = stat.dataset[lKey];
        });

        panel.classList.toggle('is-calm', isAfter);
        if (snore) snore.style.opacity = isAfter ? '0' : '1';
        if (calm) calm.style.opacity = isAfter ? '1' : '0';

        Array.prototype.forEach.call(buttons, function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.state === state));
        });
      }

      Array.prototype.forEach.call(buttons, function (b) {
        b.addEventListener('click', function () {
          apply(b.dataset.state);
        });
      });

      apply('before');
    });
  }

  /* ---------- apparitions au scroll ---------- */
  function initReveal(root) {
    var targets = root.querySelectorAll('[data-alc-reveal]');
    if (!targets.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (t) {
        t.classList.add('rv', 'in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    /* Un élément déjà visible au chargement ne doit jamais passer par
       opacity:0. Le faire retarde sa peinture jusqu'au script + DOMContentLoaded
       + observateur, ce qui décale d'autant le LCP quand cet élément est le plus
       grand de l'écran. On ne révèle donc que ce qui commence hors écran. */
    var fold = window.innerHeight || document.documentElement.clientHeight || 0;

    /* Toutes les mesures d'abord, toutes les écritures ensuite : alterner
       lecture et écriture forcerait un recalcul de mise en page par élément. */
    var pending = [];
    Array.prototype.forEach.call(targets, function (t) {
      if (t.dataset[INIT]) return;
      pending.push({ el: t, visible: t.getBoundingClientRect().top < fold });
    });

    pending.forEach(function (item) {
      item.el.dataset[INIT] = '1';

      if (item.visible) {
        item.el.classList.add('rv', 'in');
        return;
      }

      item.el.classList.add('rv');
      io.observe(item.el);
    });
  }

  function init(root) {
    var scope = root || document;
    initNight(scope);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Éditeur de thème : une section rechargée doit se réinitialiser seule. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
  document.addEventListener('shopify:section:select', function (event) {
    init(event.target || document);
  });
})();
